import React from "react";
import { useTranslation } from "react-i18next";
import { getImageUrl } from "src/utils/getImageUrl";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { CombinedSingleValueProps } from "./types";

export const SingleValue = ({ children, data }: CombinedSingleValueProps) => {
  const { t } = useTranslation();

  const valueLabel = children as Ii18nInterpolationObject | string;

  const label =
    typeof valueLabel === "string"
      ? valueLabel
      : t(valueLabel.i18nKey, valueLabel.i18nParams);

  return (
    <span className="row-start-1 row-end-2 col-start-1 col-end-3 flex gap-2 px-2 py-2 font-semibold">
      {data?.icon && (
        <img className="w-8" src={getImageUrl(data.icon)} alt={label} />
      )}
      <span>{label}</span>
    </span>
  );
};
